import React from 'react'

import config from '../config.js'

import { Link } from 'react-router-dom'

const ListRecipe = ({ chapterUrl, recipe }) => (
  <li className="recipe-list-item">
    {/*<Link
      className="recipe-list-item__link"
      to={chapterUrl + '/' + recipe.identifier}
    >*/}
    <Link
      className="recipe-list-item__link"
      to={chapterUrl + '/' + recipe.identifier + '/' + recipe.uuid}
    >
      <img
        className="recipe-list-item__img"
        src={
          recipe.imageUrl == null
            ? config.baseUrl + '/assets/img/generic-recipe.png'
            : recipe.imageUrl + '=s200-c'
        }
        alt={recipe.title + ' Image'}
      />
      <h3 className="recipe-list-item__title">{recipe.title}</h3>
    </Link>
  </li>
)

export default ListRecipe



// WEBPACK FOOTER //
// ./src/Components/ListRecipe.js